import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  putPartnersPartnerID,
  type SavePartnerRequest,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PARTNERS_QUERY_KEYS } from "../Queries/queryKeys";

interface UpdatePartnerParams {
  partnerID: string;
  data: SavePartnerRequest;
}

export function useUpdatePartnerMutation() {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(
    ({ partnerID, data }: UpdatePartnerParams) =>
      putPartnersPartnerID(data, partnerID),
  );

  return useMutation({
    mutationFn,
    onSuccess: (_, { partnerID }) => {
      queryClient.invalidateQueries({
        queryKey: PARTNERS_QUERY_KEYS.all,
      });
      queryClient.invalidateQueries({
        queryKey: PARTNERS_QUERY_KEYS.detail(partnerID),
      });
    },
  });
}
